import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowDownIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M6.37001 7.80002C6.25282 7.68815 6.09703 7.62573 5.93501 7.62573C5.77299 7.62573 5.61721 7.68815 5.50001 7.80002L4.77001 8.53002C4.65581 8.646 4.5918 8.80225 4.5918 8.96502C4.5918 9.12779 4.65581 9.28403 4.77001 9.40002L9.57001 14.19C9.62592 14.2475 9.69278 14.2931 9.76663 14.3243C9.84049 14.3555 9.91984 14.3716 10 14.3716C10.0802 14.3716 10.1595 14.3555 10.2334 14.3243C10.3072 14.2931 10.3741 14.2475 10.43 14.19L15.23 9.40002C15.3442 9.28403 15.4082 9.12779 15.4082 8.96502C15.4082 8.80225 15.3442 8.646 15.23 8.53002L14.5 7.80002C14.3828 7.68815 14.227 7.62573 14.065 7.62573C13.903 7.62573 13.7472 7.68815 13.63 7.80002L10 11.44L6.37001 7.80002Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowDownIcon;
